// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: rtc/location_history.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Point } from "../geo/geo";
import { Timestamp } from "../google/protobuf/timestamp";

export const protobufPackage = "carbon.rtc";

/**
 * Operational states. This should be kept 1:1 with the enum values in the
 * associated rtc-locator DB schema.
 */
export enum RobotOpsState {
  ROBOT_OPS_STATE_UNSPECIFIED = 0,
  /** ROBOT_OPS_STATE_OFFLINE - Powered off or no network connection. Not */
  ROBOT_OPS_STATE_OFFLINE = 1,
  /** ROBOT_OPS_STATE_IDLE_CARBON - expected to be sent by the robot. */
  ROBOT_OPS_STATE_IDLE_CARBON = 2,
  /** ROBOT_OPS_STATE_REMOTE_CARBON - Remotely operated by Carbon. */
  ROBOT_OPS_STATE_REMOTE_CARBON = 3,
  /** ROBOT_OPS_STATE_AUTONOMOUS_CARBON - Autonomously operated by Carbon. */
  ROBOT_OPS_STATE_AUTONOMOUS_CARBON = 4,
  /** ROBOT_OPS_STATE_IDLE_CUSTOMER - Waiting for Customer to take action. */
  ROBOT_OPS_STATE_IDLE_CUSTOMER = 5,
  /** ROBOT_OPS_STATE_IN_CAB_CUSTOMER - Driven by a customer in the cab. */
  ROBOT_OPS_STATE_IN_CAB_CUSTOMER = 6,
  /** ROBOT_OPS_STATE_REMOTE_CUSTOMER - Remotely operated by customer. */
  ROBOT_OPS_STATE_REMOTE_CUSTOMER = 7,
  UNRECOGNIZED = -1,
}

export function robotOpsStateFromJSON(object: any): RobotOpsState {
  switch (object) {
    case 0:
    case "ROBOT_OPS_STATE_UNSPECIFIED":
      return RobotOpsState.ROBOT_OPS_STATE_UNSPECIFIED;
    case 1:
    case "ROBOT_OPS_STATE_OFFLINE":
      return RobotOpsState.ROBOT_OPS_STATE_OFFLINE;
    case 2:
    case "ROBOT_OPS_STATE_IDLE_CARBON":
      return RobotOpsState.ROBOT_OPS_STATE_IDLE_CARBON;
    case 3:
    case "ROBOT_OPS_STATE_REMOTE_CARBON":
      return RobotOpsState.ROBOT_OPS_STATE_REMOTE_CARBON;
    case 4:
    case "ROBOT_OPS_STATE_AUTONOMOUS_CARBON":
      return RobotOpsState.ROBOT_OPS_STATE_AUTONOMOUS_CARBON;
    case 5:
    case "ROBOT_OPS_STATE_IDLE_CUSTOMER":
      return RobotOpsState.ROBOT_OPS_STATE_IDLE_CUSTOMER;
    case 6:
    case "ROBOT_OPS_STATE_IN_CAB_CUSTOMER":
      return RobotOpsState.ROBOT_OPS_STATE_IN_CAB_CUSTOMER;
    case 7:
    case "ROBOT_OPS_STATE_REMOTE_CUSTOMER":
      return RobotOpsState.ROBOT_OPS_STATE_REMOTE_CUSTOMER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RobotOpsState.UNRECOGNIZED;
  }
}

export function robotOpsStateToJSON(object: RobotOpsState): string {
  switch (object) {
    case RobotOpsState.ROBOT_OPS_STATE_UNSPECIFIED:
      return "ROBOT_OPS_STATE_UNSPECIFIED";
    case RobotOpsState.ROBOT_OPS_STATE_OFFLINE:
      return "ROBOT_OPS_STATE_OFFLINE";
    case RobotOpsState.ROBOT_OPS_STATE_IDLE_CARBON:
      return "ROBOT_OPS_STATE_IDLE_CARBON";
    case RobotOpsState.ROBOT_OPS_STATE_REMOTE_CARBON:
      return "ROBOT_OPS_STATE_REMOTE_CARBON";
    case RobotOpsState.ROBOT_OPS_STATE_AUTONOMOUS_CARBON:
      return "ROBOT_OPS_STATE_AUTONOMOUS_CARBON";
    case RobotOpsState.ROBOT_OPS_STATE_IDLE_CUSTOMER:
      return "ROBOT_OPS_STATE_IDLE_CUSTOMER";
    case RobotOpsState.ROBOT_OPS_STATE_IN_CAB_CUSTOMER:
      return "ROBOT_OPS_STATE_IN_CAB_CUSTOMER";
    case RobotOpsState.ROBOT_OPS_STATE_REMOTE_CUSTOMER:
      return "ROBOT_OPS_STATE_REMOTE_CUSTOMER";
    case RobotOpsState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface RobotData {
  /** 0 is not a valid task_id and can signify no task. */
  taskId: number;
  /**
   * Indicates whether the robot was making progress on its task, using a
   * task-specific definition of "active" that is determined by the robot. For
   * example, for a laserweeding task, the state might be determined by whether
   * the hitch is lowered.
   */
  active: boolean;
  /**
   * Objective ID is for tracking purposes and ease of querying contiguous
   * location data. 0 is not a valid objective_id and signifies no objective.
   */
  objectiveId: number;
  /**
   * Job ID is useful for when a robot is assigned to a job, but might not
   * have a task or objective assigned yet. 0 is not a valid job_id and
   * signifies no job.
   */
  jobId: number;
  /**
   * Most recent robot operational state. Note: it is possible for multiple
   * state transitions to occur between updates; this is last-write-wins.
   */
  opsState: RobotOpsState;
  /**
   * Overwatch coverage, relayed off the SafetyAction stream so locator can
   * keep a row per coverage epoch for the blind-zone clearance. Omitted when
   * overwatch is not reporting or not nominal.
   */
  blindZoneCoverageSinceMs?: number | undefined;
  blindZoneCoverageLastOkMs?: number | undefined;
}

export interface LocationHistoryRecord {
  point:
    | Point
    | undefined;
  /** Facing direction of the robot, if available from hardware. */
  headingDegrees?: number | undefined;
  timestamp: string | undefined;
  data: RobotData | undefined;
}

export interface LocationHistoryRecordList {
  records: LocationHistoryRecord[];
}

export interface LogLocationHistoryRequest {
  history: LocationHistoryRecordList | undefined;
}

export interface ListRobotsRequest {
  pageSize: number;
  pageToken: string;
  /** If not empty, only list robots with the given serials. */
  robotSerials: string[];
}

export interface ListRobotsResponse {
  nextPageToken: string;
  robots: RobotSummary[];
}

export interface RobotSummary {
  serial: string;
  lastSeen: LocationHistoryRecord | undefined;
}

export interface ListLocationHistoryRequest {
  pageSize: number;
  pageToken: string;
  robotSerial: string;
  start: string | undefined;
  end: string | undefined;
  desc: boolean;
  includeClosest: boolean;
  taskId: number;
  objectiveId: number;
}

export interface ListLocationHistoryResponse {
  nextPageToken: string;
  history: LocationHistoryRecordList | undefined;
}

function createBaseRobotData(): RobotData {
  return {
    taskId: 0,
    active: false,
    objectiveId: 0,
    jobId: 0,
    opsState: 0,
    blindZoneCoverageSinceMs: undefined,
    blindZoneCoverageLastOkMs: undefined,
  };
}

export const RobotData: MessageFns<RobotData> = {
  encode(message: RobotData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.taskId !== 0) {
      writer.uint32(8).uint64(message.taskId);
    }
    if (message.active !== false) {
      writer.uint32(16).bool(message.active);
    }
    if (message.objectiveId !== 0) {
      writer.uint32(24).uint64(message.objectiveId);
    }
    if (message.jobId !== 0) {
      writer.uint32(32).uint64(message.jobId);
    }
    if (message.opsState !== 0) {
      writer.uint32(40).int32(message.opsState);
    }
    if (message.blindZoneCoverageSinceMs !== undefined) {
      writer.uint32(48).int64(message.blindZoneCoverageSinceMs);
    }
    if (message.blindZoneCoverageLastOkMs !== undefined) {
      writer.uint32(56).int64(message.blindZoneCoverageLastOkMs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RobotData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRobotData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.taskId = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.active = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.objectiveId = longToNumber(reader.uint64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.jobId = longToNumber(reader.uint64());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.opsState = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.blindZoneCoverageSinceMs = longToNumber(reader.int64());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.blindZoneCoverageLastOkMs = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RobotData {
    return {
      taskId: isSet(object.taskId)
        ? globalThis.Number(object.taskId)
        : isSet(object.task_id)
        ? globalThis.Number(object.task_id)
        : 0,
      active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
      objectiveId: isSet(object.objectiveId)
        ? globalThis.Number(object.objectiveId)
        : isSet(object.objective_id)
        ? globalThis.Number(object.objective_id)
        : 0,
      jobId: isSet(object.jobId)
        ? globalThis.Number(object.jobId)
        : isSet(object.job_id)
        ? globalThis.Number(object.job_id)
        : 0,
      opsState: isSet(object.opsState)
        ? robotOpsStateFromJSON(object.opsState)
        : isSet(object.ops_state)
        ? robotOpsStateFromJSON(object.ops_state)
        : 0,
      blindZoneCoverageSinceMs: isSet(object.blindZoneCoverageSinceMs)
        ? globalThis.Number(object.blindZoneCoverageSinceMs)
        : isSet(object.blind_zone_coverage_since_ms)
        ? globalThis.Number(object.blind_zone_coverage_since_ms)
        : undefined,
      blindZoneCoverageLastOkMs: isSet(object.blindZoneCoverageLastOkMs)
        ? globalThis.Number(object.blindZoneCoverageLastOkMs)
        : isSet(object.blind_zone_coverage_last_ok_ms)
        ? globalThis.Number(object.blind_zone_coverage_last_ok_ms)
        : undefined,
    };
  },

  toJSON(message: RobotData): unknown {
    const obj: any = {};
    if (message.taskId !== 0) {
      obj.taskId = Math.round(message.taskId);
    }
    if (message.active !== false) {
      obj.active = message.active;
    }
    if (message.objectiveId !== 0) {
      obj.objectiveId = Math.round(message.objectiveId);
    }
    if (message.jobId !== 0) {
      obj.jobId = Math.round(message.jobId);
    }
    if (message.opsState !== 0) {
      obj.opsState = robotOpsStateToJSON(message.opsState);
    }
    if (message.blindZoneCoverageSinceMs !== undefined) {
      obj.blindZoneCoverageSinceMs = Math.round(message.blindZoneCoverageSinceMs);
    }
    if (message.blindZoneCoverageLastOkMs !== undefined) {
      obj.blindZoneCoverageLastOkMs = Math.round(message.blindZoneCoverageLastOkMs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RobotData>, I>>(base?: I): RobotData {
    return RobotData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RobotData>, I>>(object: I): RobotData {
    const message = createBaseRobotData();
    message.taskId = object.taskId ?? 0;
    message.active = object.active ?? false;
    message.objectiveId = object.objectiveId ?? 0;
    message.jobId = object.jobId ?? 0;
    message.opsState = object.opsState ?? 0;
    message.blindZoneCoverageSinceMs = object.blindZoneCoverageSinceMs ?? undefined;
    message.blindZoneCoverageLastOkMs = object.blindZoneCoverageLastOkMs ?? undefined;
    return message;
  },
};

function createBaseLocationHistoryRecord(): LocationHistoryRecord {
  return { point: undefined, headingDegrees: undefined, timestamp: undefined, data: undefined };
}

export const LocationHistoryRecord: MessageFns<LocationHistoryRecord> = {
  encode(message: LocationHistoryRecord, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.point !== undefined) {
      Point.encode(message.point, writer.uint32(10).fork()).join();
    }
    if (message.headingDegrees !== undefined) {
      writer.uint32(33).double(message.headingDegrees);
    }
    if (message.timestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.timestamp), writer.uint32(18).fork()).join();
    }
    if (message.data !== undefined) {
      RobotData.encode(message.data, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LocationHistoryRecord {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLocationHistoryRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.point = Point.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.headingDegrees = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.timestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.data = RobotData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LocationHistoryRecord {
    return {
      point: isSet(object.point) ? Point.fromJSON(object.point) : undefined,
      headingDegrees: isSet(object.headingDegrees)
        ? globalThis.Number(object.headingDegrees)
        : isSet(object.heading_degrees)
        ? globalThis.Number(object.heading_degrees)
        : undefined,
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : undefined,
      data: isSet(object.data) ? RobotData.fromJSON(object.data) : undefined,
    };
  },

  toJSON(message: LocationHistoryRecord): unknown {
    const obj: any = {};
    if (message.point !== undefined) {
      obj.point = Point.toJSON(message.point);
    }
    if (message.headingDegrees !== undefined) {
      obj.headingDegrees = message.headingDegrees;
    }
    if (message.timestamp !== undefined) {
      obj.timestamp = message.timestamp;
    }
    if (message.data !== undefined) {
      obj.data = RobotData.toJSON(message.data);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LocationHistoryRecord>, I>>(base?: I): LocationHistoryRecord {
    return LocationHistoryRecord.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LocationHistoryRecord>, I>>(object: I): LocationHistoryRecord {
    const message = createBaseLocationHistoryRecord();
    message.point = (object.point !== undefined && object.point !== null) ? Point.fromPartial(object.point) : undefined;
    message.headingDegrees = object.headingDegrees ?? undefined;
    message.timestamp = object.timestamp ?? undefined;
    message.data = (object.data !== undefined && object.data !== null) ? RobotData.fromPartial(object.data) : undefined;
    return message;
  },
};

function createBaseLocationHistoryRecordList(): LocationHistoryRecordList {
  return { records: [] };
}

export const LocationHistoryRecordList: MessageFns<LocationHistoryRecordList> = {
  encode(message: LocationHistoryRecordList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.records) {
      LocationHistoryRecord.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LocationHistoryRecordList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLocationHistoryRecordList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.records.push(LocationHistoryRecord.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LocationHistoryRecordList {
    return {
      records: globalThis.Array.isArray(object?.records)
        ? object.records.map((e: any) => LocationHistoryRecord.fromJSON(e))
        : [],
    };
  },

  toJSON(message: LocationHistoryRecordList): unknown {
    const obj: any = {};
    if (message.records?.length) {
      obj.records = message.records.map((e) => LocationHistoryRecord.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LocationHistoryRecordList>, I>>(base?: I): LocationHistoryRecordList {
    return LocationHistoryRecordList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LocationHistoryRecordList>, I>>(object: I): LocationHistoryRecordList {
    const message = createBaseLocationHistoryRecordList();
    message.records = object.records?.map((e) => LocationHistoryRecord.fromPartial(e)) || [];
    return message;
  },
};

function createBaseLogLocationHistoryRequest(): LogLocationHistoryRequest {
  return { history: undefined };
}

export const LogLocationHistoryRequest: MessageFns<LogLocationHistoryRequest> = {
  encode(message: LogLocationHistoryRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.history !== undefined) {
      LocationHistoryRecordList.encode(message.history, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LogLocationHistoryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLogLocationHistoryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.history = LocationHistoryRecordList.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LogLocationHistoryRequest {
    return { history: isSet(object.history) ? LocationHistoryRecordList.fromJSON(object.history) : undefined };
  },

  toJSON(message: LogLocationHistoryRequest): unknown {
    const obj: any = {};
    if (message.history !== undefined) {
      obj.history = LocationHistoryRecordList.toJSON(message.history);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LogLocationHistoryRequest>, I>>(base?: I): LogLocationHistoryRequest {
    return LogLocationHistoryRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LogLocationHistoryRequest>, I>>(object: I): LogLocationHistoryRequest {
    const message = createBaseLogLocationHistoryRequest();
    message.history = (object.history !== undefined && object.history !== null)
      ? LocationHistoryRecordList.fromPartial(object.history)
      : undefined;
    return message;
  },
};

function createBaseListRobotsRequest(): ListRobotsRequest {
  return { pageSize: 0, pageToken: "", robotSerials: [] };
}

export const ListRobotsRequest: MessageFns<ListRobotsRequest> = {
  encode(message: ListRobotsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageSize !== 0) {
      writer.uint32(8).int32(message.pageSize);
    }
    if (message.pageToken !== "") {
      writer.uint32(18).string(message.pageToken);
    }
    for (const v of message.robotSerials) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListRobotsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListRobotsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.robotSerials.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListRobotsRequest {
    return {
      pageSize: isSet(object.pageSize)
        ? globalThis.Number(object.pageSize)
        : isSet(object.page_size)
        ? globalThis.Number(object.page_size)
        : 0,
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : "",
      robotSerials: globalThis.Array.isArray(object?.robotSerials)
        ? object.robotSerials.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.robot_serials)
        ? object.robot_serials.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ListRobotsRequest): unknown {
    const obj: any = {};
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.pageToken !== "") {
      obj.pageToken = message.pageToken;
    }
    if (message.robotSerials?.length) {
      obj.robotSerials = message.robotSerials;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListRobotsRequest>, I>>(base?: I): ListRobotsRequest {
    return ListRobotsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListRobotsRequest>, I>>(object: I): ListRobotsRequest {
    const message = createBaseListRobotsRequest();
    message.pageSize = object.pageSize ?? 0;
    message.pageToken = object.pageToken ?? "";
    message.robotSerials = object.robotSerials?.map((e) => e) || [];
    return message;
  },
};

function createBaseListRobotsResponse(): ListRobotsResponse {
  return { nextPageToken: "", robots: [] };
}

export const ListRobotsResponse: MessageFns<ListRobotsResponse> = {
  encode(message: ListRobotsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nextPageToken !== "") {
      writer.uint32(10).string(message.nextPageToken);
    }
    for (const v of message.robots) {
      RobotSummary.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListRobotsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListRobotsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nextPageToken = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.robots.push(RobotSummary.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListRobotsResponse {
    return {
      nextPageToken: isSet(object.nextPageToken)
        ? globalThis.String(object.nextPageToken)
        : isSet(object.next_page_token)
        ? globalThis.String(object.next_page_token)
        : "",
      robots: globalThis.Array.isArray(object?.robots) ? object.robots.map((e: any) => RobotSummary.fromJSON(e)) : [],
    };
  },

  toJSON(message: ListRobotsResponse): unknown {
    const obj: any = {};
    if (message.nextPageToken !== "") {
      obj.nextPageToken = message.nextPageToken;
    }
    if (message.robots?.length) {
      obj.robots = message.robots.map((e) => RobotSummary.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListRobotsResponse>, I>>(base?: I): ListRobotsResponse {
    return ListRobotsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListRobotsResponse>, I>>(object: I): ListRobotsResponse {
    const message = createBaseListRobotsResponse();
    message.nextPageToken = object.nextPageToken ?? "";
    message.robots = object.robots?.map((e) => RobotSummary.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRobotSummary(): RobotSummary {
  return { serial: "", lastSeen: undefined };
}

export const RobotSummary: MessageFns<RobotSummary> = {
  encode(message: RobotSummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.serial !== "") {
      writer.uint32(10).string(message.serial);
    }
    if (message.lastSeen !== undefined) {
      LocationHistoryRecord.encode(message.lastSeen, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RobotSummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRobotSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.serial = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.lastSeen = LocationHistoryRecord.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RobotSummary {
    return {
      serial: isSet(object.serial) ? globalThis.String(object.serial) : "",
      lastSeen: isSet(object.lastSeen)
        ? LocationHistoryRecord.fromJSON(object.lastSeen)
        : isSet(object.last_seen)
        ? LocationHistoryRecord.fromJSON(object.last_seen)
        : undefined,
    };
  },

  toJSON(message: RobotSummary): unknown {
    const obj: any = {};
    if (message.serial !== "") {
      obj.serial = message.serial;
    }
    if (message.lastSeen !== undefined) {
      obj.lastSeen = LocationHistoryRecord.toJSON(message.lastSeen);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RobotSummary>, I>>(base?: I): RobotSummary {
    return RobotSummary.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RobotSummary>, I>>(object: I): RobotSummary {
    const message = createBaseRobotSummary();
    message.serial = object.serial ?? "";
    message.lastSeen = (object.lastSeen !== undefined && object.lastSeen !== null)
      ? LocationHistoryRecord.fromPartial(object.lastSeen)
      : undefined;
    return message;
  },
};

function createBaseListLocationHistoryRequest(): ListLocationHistoryRequest {
  return {
    pageSize: 0,
    pageToken: "",
    robotSerial: "",
    start: undefined,
    end: undefined,
    desc: false,
    includeClosest: false,
    taskId: 0,
    objectiveId: 0,
  };
}

export const ListLocationHistoryRequest: MessageFns<ListLocationHistoryRequest> = {
  encode(message: ListLocationHistoryRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageSize !== 0) {
      writer.uint32(8).int32(message.pageSize);
    }
    if (message.pageToken !== "") {
      writer.uint32(18).string(message.pageToken);
    }
    if (message.robotSerial !== "") {
      writer.uint32(26).string(message.robotSerial);
    }
    if (message.start !== undefined) {
      Timestamp.encode(toTimestamp(message.start), writer.uint32(34).fork()).join();
    }
    if (message.end !== undefined) {
      Timestamp.encode(toTimestamp(message.end), writer.uint32(42).fork()).join();
    }
    if (message.desc !== false) {
      writer.uint32(48).bool(message.desc);
    }
    if (message.includeClosest !== false) {
      writer.uint32(56).bool(message.includeClosest);
    }
    if (message.taskId !== 0) {
      writer.uint32(64).uint64(message.taskId);
    }
    if (message.objectiveId !== 0) {
      writer.uint32(72).uint64(message.objectiveId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListLocationHistoryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListLocationHistoryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.start = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.end = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.desc = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.includeClosest = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.taskId = longToNumber(reader.uint64());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.objectiveId = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListLocationHistoryRequest {
    return {
      pageSize: isSet(object.pageSize)
        ? globalThis.Number(object.pageSize)
        : isSet(object.page_size)
        ? globalThis.Number(object.page_size)
        : 0,
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : "",
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : "",
      start: isSet(object.start) ? globalThis.String(object.start) : undefined,
      end: isSet(object.end) ? globalThis.String(object.end) : undefined,
      desc: isSet(object.desc) ? globalThis.Boolean(object.desc) : false,
      includeClosest: isSet(object.includeClosest)
        ? globalThis.Boolean(object.includeClosest)
        : isSet(object.include_closest)
        ? globalThis.Boolean(object.include_closest)
        : false,
      taskId: isSet(object.taskId)
        ? globalThis.Number(object.taskId)
        : isSet(object.task_id)
        ? globalThis.Number(object.task_id)
        : 0,
      objectiveId: isSet(object.objectiveId)
        ? globalThis.Number(object.objectiveId)
        : isSet(object.objective_id)
        ? globalThis.Number(object.objective_id)
        : 0,
    };
  },

  toJSON(message: ListLocationHistoryRequest): unknown {
    const obj: any = {};
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.pageToken !== "") {
      obj.pageToken = message.pageToken;
    }
    if (message.robotSerial !== "") {
      obj.robotSerial = message.robotSerial;
    }
    if (message.start !== undefined) {
      obj.start = message.start;
    }
    if (message.end !== undefined) {
      obj.end = message.end;
    }
    if (message.desc !== false) {
      obj.desc = message.desc;
    }
    if (message.includeClosest !== false) {
      obj.includeClosest = message.includeClosest;
    }
    if (message.taskId !== 0) {
      obj.taskId = Math.round(message.taskId);
    }
    if (message.objectiveId !== 0) {
      obj.objectiveId = Math.round(message.objectiveId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListLocationHistoryRequest>, I>>(base?: I): ListLocationHistoryRequest {
    return ListLocationHistoryRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListLocationHistoryRequest>, I>>(object: I): ListLocationHistoryRequest {
    const message = createBaseListLocationHistoryRequest();
    message.pageSize = object.pageSize ?? 0;
    message.pageToken = object.pageToken ?? "";
    message.robotSerial = object.robotSerial ?? "";
    message.start = object.start ?? undefined;
    message.end = object.end ?? undefined;
    message.desc = object.desc ?? false;
    message.includeClosest = object.includeClosest ?? false;
    message.taskId = object.taskId ?? 0;
    message.objectiveId = object.objectiveId ?? 0;
    return message;
  },
};

function createBaseListLocationHistoryResponse(): ListLocationHistoryResponse {
  return { nextPageToken: "", history: undefined };
}

export const ListLocationHistoryResponse: MessageFns<ListLocationHistoryResponse> = {
  encode(message: ListLocationHistoryResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nextPageToken !== "") {
      writer.uint32(10).string(message.nextPageToken);
    }
    if (message.history !== undefined) {
      LocationHistoryRecordList.encode(message.history, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListLocationHistoryResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListLocationHistoryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nextPageToken = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.history = LocationHistoryRecordList.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListLocationHistoryResponse {
    return {
      nextPageToken: isSet(object.nextPageToken)
        ? globalThis.String(object.nextPageToken)
        : isSet(object.next_page_token)
        ? globalThis.String(object.next_page_token)
        : "",
      history: isSet(object.history) ? LocationHistoryRecordList.fromJSON(object.history) : undefined,
    };
  },

  toJSON(message: ListLocationHistoryResponse): unknown {
    const obj: any = {};
    if (message.nextPageToken !== "") {
      obj.nextPageToken = message.nextPageToken;
    }
    if (message.history !== undefined) {
      obj.history = LocationHistoryRecordList.toJSON(message.history);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListLocationHistoryResponse>, I>>(base?: I): ListLocationHistoryResponse {
    return ListLocationHistoryResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListLocationHistoryResponse>, I>>(object: I): ListLocationHistoryResponse {
    const message = createBaseListLocationHistoryResponse();
    message.nextPageToken = object.nextPageToken ?? "";
    message.history = (object.history !== undefined && object.history !== null)
      ? LocationHistoryRecordList.fromPartial(object.history)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(dateStr: string): Timestamp {
  const date = new globalThis.Date(dateStr);
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): string {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis).toISOString();
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
